export const chunk = (arr, len) => {
  const chunks = [];
  let i = 0;
  const n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }

  return chunks;
};

export const sortAscending = (arr: any, sortKey: string) => {
  return arr.sort((a: any, b: any) => {
    if (a[sortKey] < b[sortKey]) {
      return -1;
    }
    if (a[sortKey] > b[sortKey]) {
      return 1;
    }
    return 0;
  });
};

export const sortDescending = (arr: any, sortKey: string) => {
  return arr.sort((a: any, b: any) => {
    if (a[sortKey] > b[sortKey]) {
      return -1;
    }
    if (b[sortKey] > a[sortKey]) {
      return 1;
    }
    return 0;
  });
};



// WEBPACK FOOTER //
// ./utils/arrayUtil.ts